module.exports = __webpack_public_path__ + "od-checkbox-checked-icon/od-checkbox-checked-icon-3bdf38688f016c7e242fb1eae9570027.svg";